export default __webpack_public_path__ + "static/fire_door_b.55347616a00f989ee1ecc61c528e0433.png";